<template>
  <v-dialog :value="true" max-width="400" content-class="rounded-xl" @click:outside="cancel">
    <v-card>
      <v-card-title>
        <vs-heading>{{ title }}</vs-heading>
      </v-card-title>

      <v-card-text class="pb-2">
        <vs-text v-html="dialogText" />
      </v-card-text>

      <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <vs-button label="Cancel" type="secondary" class="mr-2" @click="cancel" />
        <vs-button :label="buttonText" @click="confirm" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import VsButton from '@/components/vision/VsButton.vue'
import VsText from '@/components/vision/VsText.vue'
import { computed } from 'vue'

const props = defineProps<{
  hubName: string
  orgName: string
  autoConnect: boolean
}>()

const title = computed(() => (props.autoConnect ? 'Confirm connection ' : 'Confirm invitation'))

const dialogText = computed(() => {
  const clientString =
    props.hubName === props.orgName ? props.hubName : `${props.orgName} - ${props.hubName}`

  if (props.autoConnect) {
    return `You can automatically connect to <b>${clientString}</b> without sending an invitation. Do you want to auto-connect now?`
  }

  return `<b>${clientString}</b> admins must accept your invitation before you can create jobs for them.`
})

const buttonText = computed(() => (props.autoConnect ? 'Connect' : 'Invite'))

const emits = defineEmits<{
  (event: 'close')
  (event: 'confirm')
}>()

const cancel = () => {
  emits('close')
}

const confirm = () => {
  emits('confirm')
}
</script>
